// Matches a UK postcode (outward code optionally followed by inward code).
// Capture group 1 is the outward code, e.g. "M1", "SW1A", "GU32", "EC1A".
const UK_POSTCODE_REGEX = /^([A-Z]{1,2}[0-9][A-Z0-9]?)\s*([0-9][A-Z]{2})?$/i;

export function extractOutwardCode(value: string | null | undefined): string | null {
  if (!value) return null;
  const normalised = value.trim().toUpperCase().replace(/\s+/g, ' ');
  if (!normalised) return null;
  const match = UK_POSTCODE_REGEX.exec(normalised);
  return match ? match[1] : null;
}

export const EX_WORKS_POSTCODE = 'X';

export function matchAreaCode<T extends { postCode: string }>(
  value: string | null | undefined,
  areaCodes: readonly T[],
): T | null {
  const outward = extractOutwardCode(value);
  if (!outward) return null;
  let best: T | null = null;
  for (const area of areaCodes) {
    if (!area.postCode) continue;
    const prefix = area.postCode.toUpperCase().trim();
    if (!prefix) continue;
    // The Ex Works marker is only reachable via the checkbox, never by
    // typing a postcode that happens to start with "X".
    if (prefix === EX_WORKS_POSTCODE) continue;
    if (!outward.startsWith(prefix)) continue;
    if (best === null || prefix.length > best.postCode.length) {
      best = area;
    }
  }
  return best;
}
